import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import * as appealApi from './appealApi';
import type { AppealStatus } from './appealApi';
import { useCurrentUser } from './useAuth';

export const APPEAL_QUERY_KEY = ['account', 'appeal'] as const;

/** Read the kid's most recent appeal (or null). The query is only
 *  enabled for signed-in suspended users — the banner doesn't need
 *  it otherwise. */
export function useMyAppeal(): UseQueryResult<AppealStatus | null, Error> {
  const { data: user } = useCurrentUser();
  return useQuery({
    queryKey: APPEAL_QUERY_KEY,
    queryFn: appealApi.getMyAppeal,
    enabled: Boolean(user?.suspended),
    staleTime: 30_000,
  });
}

export function useFileAppeal(): UseMutationResult<AppealStatus, Error, { message: string }> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ message }) => appealApi.fileAppeal(message),
    onSuccess: (data) => {
      qc.setQueryData(APPEAL_QUERY_KEY, data);
    },
  });
}
